export type FontFaceOutcome = 'loaded' | 'failed';

export interface RegisterFontFaceInput {
  /** 등록할 패밀리 이름 — 렌더러 fontString 이 이 이름으로 글꼴을 고른다. 뷰어는 q-{fontId} 별칭을 쓴다(V9). */
  readonly family: string;
  /** 글꼴 파일 표시 주소(서명 URL). */
  readonly url: string;
}

/**
 * 글꼴 파일을 FontFace 로 등록하고 불러온다. 실패해도 던지지 않고 'failed' 를 돌려준다 — 대체 글꼴로 그릴지(뷰어)
 * 실패 상태로 남길지(편집기)는 호출자가 정한다. 같은 이름·주소를 두 번 등록하지 않게 막는 것도 호출자 몫이다.
 */
export const registerFontFace = async (input: RegisterFontFaceInput): Promise<FontFaceOutcome> => {
  try {
    const face = new FontFace(input.family, `url(${input.url})`);
    document.fonts.add(face);
    await face.load();
    return 'loaded';
  } catch {
    return 'failed';
  }
};
